import { render } from "./ContextMenu.vue?vue&type=template&id=4652b27e&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=4652b27e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4652b27e"]])

export default __exports__